import { render } from "./permalink-view.vue?vue&type=template&id=0a3e223c"
import script from "./permalink-view.vue?vue&type=script&lang=js"
export * from "./permalink-view.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__